//src/components/ProductList.jsx :-
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import { tokens } from "../../theme";
import axios from 'axios';
import Box from '@mui/material/Box';
import { useMediaQuery, useTheme, TextField, InputAdornment } from "@mui/material";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { Button, IconButton } from '@mui/material';
import { Add, Edit, Delete, Search, Refresh } from '@mui/icons-material';
import AddProduct from './AddProduct';
import EditProduct from './EditProduct';
import IssueItemSingle from './IssueItemSingle';
import ReceiveItemSingle from './ReceiveItemSingle';
import env from "react-dotenv";
import CommonTableActions from '../../components/CommonTableActions'; // Import the common component
import ExcelJS from 'exceljs';
 import { saveAs } from 'file-saver';
 import SaveAltIcon from '@mui/icons-material/SaveAlt';
 import FilterListIcon from '@mui/icons-material/FilterList';
 import ClearIcon from '@mui/icons-material/Clear';
 import CustomSelect1 from '../../utils/CustomSelect1'; // Import the CustomSelect component
 import {
  createWorkbook,
  createWorksheet,
  addTitleRow,
  addSummaryRow,
  addHeaders,
  applyCellStyles,
  setColumnWidths
} from '../../utils/excelStyles'; // Import the Excel styling functions

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [openEditProductQuantity, setOpenEditProductQuantity] = useState(false);
  const [selectedProductQuantity, setSelectedProductQuantity] = useState(null);
  const [openReceiveProduct, setOpenReceiveProduct] = useState(false); // For Receive Item
  const [selectedProductReceive, setSelectedProductReceive] = useState(null); // For selected product to receive
  const [searchTerm, setSearchTerm] = useState(''); // For search input
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedMaterials, setSelectedMaterials] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [uniqueMaterials, setUniqueMaterials] = useState([]);
  const [uniqueCategories, setUniqueCategories] = useState([]);
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false); // New state for advanced filters

  // States to control dropdown opens separately
  const [openMaterialsDropdown, setOpenMaterialsDropdown] = useState(false);
  const [openCategoriesDropdown, setOpenCategoriesDropdown] = useState(false);

  const user = useSelector((state) => state.user);
  // console.log("User  object: ", user); // Log the entire user object
  // console.log("User  department: ", user?.department); // Log the department
  // const isAdmin = user?.role === 'Store Admin'; // Determine if the user is an Admin
  // Check if the user's department includes "Store"
  const isAdmin = (user?.role === 'Admin' && user?.department?.includes('Store')) || 
                  (user?.role === 'Super Admin' && user?.department?.includes('Store'));

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!location.key || location.key === 'default') {
      navigate("/");
    }
  }, [location, navigate]);

  // const fetchProducts = () => {
  //   axios
  //     .get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/products`)
  //     .then((response) => setProducts(response.data))
  //     .catch((error) => console.error('Error fetching products:', error));
  // };

  const fetchProducts = () => {
    axios
      .get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/products`)
      .then((response) => {
        setProducts(response.data);
        setFilteredProducts(response.data); // Initialize filtered products
        // Extract unique materials and categories for filtering
        setUniqueMaterials([...new Set(response.data.map(product => product.product_name))]);
        setUniqueCategories([...new Set(response.data.map(product => product.item_category))]);
      })
      .catch((error) => console.error('Error fetching products:', error));
  };

  useEffect(() => {
    fetchProducts();
    fetchRawMaterials();
    fetchCategories();

  }, []);

  const fetchRawMaterials = () => {
    axios
      .get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/products/list`)
      .then((response) => {
        // const materials = response.data.map(item => item.product_name); // Adjust based on your API response structure
        // setUniqueMaterials(materials);
        // Assuming the response is an array of objects with a product_name property
      setUniqueMaterials(response.data); // Ensure this is an array of objects
      })
      .catch((error) => console.error('Error fetching raw materials:', error));
  };

  const fetchCategories = () => {
    axios
      .get(`${process.env.REACT_APP_PJCBACKEND_URL}/api/products/categories`)
      .then((response) => {
        // Filter out null or empty categories
        const categories = response.data
          .map(item => item.item_category)
          .filter(category => category !== null && category !== ""); // Exclude null and empty strings
        setUniqueCategories(categories);
      })
      .catch((error) => console.error('Error fetching categories:', error));
  };

  const handleOpenAdd = () => {
    setOpenAdd(true);
  };

  const handleOpenEdit = (product) => {
    setSelectedProduct(product);
    setOpenEdit(true);
  };

  const handleOpenEditProductQuantity = (product) => {
    setSelectedProductQuantity(product);
    setOpenEditProductQuantity(true);
  };

  const handleCloseAdd = () => {
    setOpenAdd(false);
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
  };

  const handleCloseEditProductQuantity = () => {
    setOpenEditProductQuantity(false);
  }

  const handleDeleteProduct = (id) => {
    axios
      .delete(`${process.env.REACT_APP_PJCBACKEND_URL}/api/products/${id}`)
      .then(() => {
        fetchProducts(); // Re-fetch products after delete
      })
      .catch((error) => console.error('Error deleting product:', error));
  };

  const handleOpenReceiveProduct = (product) => {
    setSelectedProductReceive(product);
    setOpenReceiveProduct(true); // Open receive item dialog/modal
  };

  const handleCloseReceiveProduct = () => {
    setOpenReceiveProduct(false);
  };

//   const handleSearch = (e) => {
//     const value = e.target.value.toLowerCase();
//     setSearchTerm(value);
//     if (!value) {
//       fetchProducts(); // Reset products when search is cleared
//       return;
//     }
//     filterProducts(value, selectedMaterials, selectedCategories);
//     const filtered = products.filter((product) =>
//       Object.values(product).some((field) =>
//         field && field.toString().toLowerCase().includes(value)
//       )
//     );

//     setProducts(filtered);
// };

const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchTerm(value);
    // Filter products based on search term
    const filtered = products.filter((product) =>
      Object.values(product).some((field) =>
        field && field.toString().toLowerCase().includes(value)
      )
    );
    setFilteredProducts(filtered);
  };

// const handleSearch = (e) => {
//     const value = e.target.value.toLowerCase();
//     setSearchTerm(value);
//     filterProducts(value, selectedMaterials, selectedCategories);
//   };

const filterProducts = (searchTerm, selectedMaterials, selectedCategories) => {
    const filtered = products.filter((product) => {
      const matchesSearch = product.product_name.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesMaterial = selectedMaterials.length === 0 || selectedMaterials.includes(product.product_name);
      const matchesCategory = selectedCategories.length === 0 || selectedCategories.includes(product.item_category);
      return matchesSearch && matchesMaterial && matchesCategory;
    });
    setFilteredProducts(filtered);
  };
  
  // const handleMaterialChange = (selectedValues) => {
  //   setSelectedMaterials(selectedValues); // Update state with the selected values
  //   filterProducts(); // Apply filters
  // };
  // const handleCategoryChange = (selectedValues) => {
  //   setSelectedCategories(selectedValues); // Update state with the selected values
  //   filterProducts(); // Apply filters
  // };

  const handleMaterialChange = (selectedValues) => {
    setSelectedMaterials(selectedValues); // Update state with the selected values
    filterProducts(searchTerm, selectedValues, selectedCategories); // Apply filters
  };
  const handleCategoryChange = (selectedValues) => {
    setSelectedCategories(selectedValues); // Update state with the selected values
    filterProducts(searchTerm, selectedMaterials, selectedValues); // Apply filters
  };

 const handleExport = async () => {
    const workbook = createWorkbook();
    const worksheet = createWorksheet(workbook, 'Raw materials');
    addTitleRow(worksheet, 'Raw material List');
    addSummaryRow(worksheet, 'Summary of Raw materials');
    
    const headers = ['RM Code', 'Raw Material Name', 'Category', 'Quantity', 'Daily Consumption', 'Backup Time', 'Cost Per Unit', 'Base UOM', 'Location'];
    addHeaders(worksheet, headers);
    
    // Add data rows
    filteredProducts.forEach(product => {
      worksheet.addRow([
        product.product_code || '', // Ensure empty values are handled
        product.product_name || '',
        product.item_category || '',
        product.quantity || '',
        product.daily_consumption || '',
        product.backup_time || '',
        product.cost_per_unit || '',
        product.base_uom || '',
        product.location || '',
      ]);
    });
    applyCellStyles(worksheet);
    setColumnWidths(worksheet, [18, 50, 25, 15, 20, 15, 15, 15, 15]); // Set column widths
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/octet-stream' });
    saveAs(blob, 'RawMaterialsData.xlsx');
  };

  const clearFilters = () => {
    setSearchTerm("");
    setSelectedMaterials([]);
    setSelectedCategories([]);
    setFilteredProducts(products); // Reset filtered products to all products
  };
  
  const columns = [
    { field: 'product_code', headerName: 'RM Code', width: 100 },
     { field: 'product_name', headerName: 'Raw Material Name', width: 340 },
     { field: 'item_category', headerName: 'Category', width: 160 },
     { field: 'quantity', headerName: 'Quantity', width: 100 },
     { field: 'daily_consumption', headerName: 'Daily Consumption', width: 100 },
     { field: 'backup_time', headerName: 'Backup Time', width: 100 },
     { field: 'cost_per_unit', headerName: 'Cost Per Unit', width: 100 },
     { field: 'base_uom', headerName: 'Base UOM', width: 80 },
     { field: 'location', headerName: 'Location', width: 80 },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 80,
      headerAlign: 'center', // Center align the header text
      align: 'center',       // Optional: center align the cell contents too
      renderCell: (params) => (
        <div>
          {isAdmin && ( // Only render Edit and Delete buttons for Admin
            <>
              <IconButton color="primary" onClick={() => handleOpenEdit(params.row)}>
                <Edit />
              </IconButton>
              <IconButton
                color="secondary"
                onClick={() => handleDeleteProduct(params.row.id)}
              >
                <Delete />
              </IconButton>
            </>
          )}
        </div>
      ),
    },
  ];

  const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");

  return (
    <Box style={{  
      height: 500,
      width: '95%',
      marginLeft:"180px",
      paddingRight:"90px",
      marginTop:"0px" 
      }}>
      
        {isAdmin && (
          <Button
            // variant="contained"
            color="primary"
            onClick={handleOpenAdd}
            sx={{
              // marginLeft: "1090px",
              marginTop: "5px",
              marginBottom: "10px",
              // backgroundColor: '#00308F',
              // color: '#ffffff',
              padding: '3px 5px',
              // '&:hover': {
              //   backgroundColor: '#00207E',
              // },
            }}
          >
            Add
          </Button>
        )}
            {isAdmin && (
              <Button
                // variant="contained"
                color="primary"
                onClick={handleOpenEditProductQuantity}
                sx={{
                  // marginLeft: "1090px",
                  marginTop: "5px",
                  marginBottom: "10px",
                  marginLeft: "10px",
                  // backgroundColor: '#00308F',
                  // color: '#ffffff',
                  padding: '3px 5px',
                  // '&:hover': {
                  //   backgroundColor: '#00207E',
                  // },
                }}
              >
                Issue Item
              </Button>
            )}

            {isAdmin && (
              <Button
                // variant="contained"
                color="primary"
                onClick={handleOpenReceiveProduct}
                sx={{
                  // marginLeft: "1090px",
                  marginTop: "5px",
                  marginBottom: "10px",
                  marginLeft: "10px",
                  marginRight: "10px",
                  // backgroundColor: '#00308F',
                  // color: '#ffffff',
                  padding: '3px 5px',
                  // '&:hover': {
                  //   backgroundColor: '#00207E',
                  // },
                }}
              >
                Receive Item
              </Button>
            )}
          <TextField
              variant="outlined"
              size="small"
              placeholder="Search"
              value={searchTerm}
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
              sx={{ 
                width: '770px', // Set the desired width here
                marginTop: "5px",                  
                marginBottom: "10px", 
                marginLeft: "0px",
                marginRight: "10px",
                  backgroundColor: '#ffffff',
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': {
                      borderColor: '#00308F',
                    },
                    '&:hover fieldset': {
                      borderColor: '#00207E',
                    },
                  },
                }}
          />

          <Button
        onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
        startIcon={<FilterListIcon />}
      >
        Filter
      </Button>

      <Button
        onClick={handleExport}
        startIcon={<SaveAltIcon />}
        sx={{
          marginLeft: "10px",
          marginRight: "10px",
          marginTop: "5px",
          marginBottom: "10px",
          // backgroundColor: '#00308F',
          // color: '#ffffff',
          padding: '3px 5px',
          // '&:hover': {
          //   backgroundColor: '#00207E',
          // },
        }}
      >
        Export
      </Button>

          <IconButton
          onClick={() => window.location.reload()} // Refresh the page
          color="primary"
          sx={{
            backgroundColor: '#ffffff',
            '&:hover': {
              backgroundColor: '#f0f0f0',
            },
          }}
        >
          <Refresh />
      </IconButton>

          {showAdvancedFilters && (
        <Box sx={{ marginTop: "15px", marginBottom: "10px", display: "flex", gap: "10px", flexWrap: "wrap" }}>
          <CustomSelect1
            label="Raw Material"
            value={selectedMaterials}
            onChange={handleMaterialChange}
            // onChange={(e) => setSelectedMaterials(e.target.value)}
            options={uniqueMaterials}
            open={openMaterialsDropdown}
            setOpen={setOpenMaterialsDropdown}
            getOptionLabel={(option) => option} // Adjust based on your object structure
          />
          <CustomSelect1
            label="Category"
            value={selectedCategories}
            onChange={handleCategoryChange}
            // onChange={(e) => setSelectedCategories(e.target.value)}
            options={uniqueCategories}
            open={openCategoriesDropdown}
            setOpen={setOpenCategoriesDropdown}
            getOptionLabel={(option) => option} // Adjust based on your object structure
          />

          <Button
            onClick={clearFilters}
          >
            Clear Filter
          </Button>
        </Box>
      )}

       <Box
        sx={{
          height: 500,
          overflowY: 'auto',
        }}
      >
        <DataGrid
          // rows={products}
          rows={filteredProducts}
          columns={columns}
          getRowId={(row) => row.id}
          pageSizeOptions={[10, 25, 50]}
          checkboxSelection
          disableRowSelectionOnClick
          // slots={{ toolbar: GridToolbar }}
          sx={{
            boxShadow: 1,
            border: 1,
            borderColor: 'primary.light',
            typography: 'subtitle2',
            '& .MuiDataGrid-cell:hover': {
              color: 'primary.main',
            },
            '.MuiDataGrid-columnHeaderTitle': {
              font: 'light important',
              overflow: 'visible !important'
            },
            '--DataGrid-overlayHeight': '300px'
          }}
        />
      </Box>

      <AddProduct open={openAdd} handleClose={handleCloseAdd} fetchProducts={fetchProducts} />
      {selectedProduct && (
        <EditProduct
          open={openEdit}
          handleClose={handleCloseEdit}
          productData={selectedProduct}
          fetchProducts={fetchProducts}
        />
      )}
      {/* {selectedProductQuantity && (
        <EditProductQuantity
          open={openEditProductQuantity}
          handleClose={handleCloseEditProductQuantity}
          productData={selectedProductQuantity}
          fetchProducts={fetchProducts}
        />
      )} */}
       {/* {selectedProductQuantity && (
        <IssueItem
          open={openEditProductQuantity}
          handleClose={handleCloseEditProductQuantity}
          productData={selectedProductQuantity}
          fetchProducts={fetchProducts}
        />
      )} */}
      {selectedProductQuantity && (
        <IssueItemSingle
          open={openEditProductQuantity}
          handleClose={handleCloseEditProductQuantity}
          productData={selectedProductQuantity}
          fetchProducts={fetchProducts}
        />
      )}
      {selectedProductReceive && (
        <ReceiveItemSingle // You can create a new `ReceiveProduct` component if needed
          open={openReceiveProduct}
          handleClose={handleCloseReceiveProduct}
          productData={selectedProductReceive}
          fetchProducts={fetchProducts}
        />
      )}
    </Box>
  );
};

export default ProductList;
